export default "__VITE_ASSET__Jft3Zayr__"